export const TASK_STATUSES = ['pendiente', 'en_progreso', 'completada', 'cancelada'] as const;
export type TaskStatus = (typeof TASK_STATUSES)[number];

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  pendiente: 'Pendiente',
  en_progreso: 'En progreso',
  completada: 'Completada',
  cancelada: 'Cancelada',
};

export const TASK_STATUS_COLORS: Record<TaskStatus, string> = {
  pendiente: 'var(--color-fg-subtle)',
  en_progreso: 'var(--color-warning)',
  completada: 'var(--color-success)',
  cancelada: 'var(--color-fg-subtle)',
};

// Kanban muestra los 4 status. La diferencia con leads es que cancelada
// SÍ aparece como columna porque sigue siendo accionable (re-abrir).
export const KANBAN_STATUSES: readonly TaskStatus[] = [
  'pendiente',
  'en_progreso',
  'completada',
  'cancelada',
];
